import React from 'react';
import { resolveImage } from '../../../utils/api';
import BilingualField from '../../../components/common/BilingualField';

export default function AboutEditor({ content, handleBilingualChange, handleChange, handleFeatureChange, handleImageChange, aboutImagePreview }) {
  return (
    <div className="dash-card mb-4" style={{ maxWidth: 900 }}>
      <h3 className="dash-card-title mb-4">About Us Section</h3>

      <div className="form-row-2">
        <BilingualField
          label="Overline"
          fieldName="aboutOverline"
          value={content.aboutOverline}
          onChange={handleBilingualChange}
          placeholder="About ETS Academy"
        />
        <div className="form-group">
          <label className="form-label-style">Badge Big Text (number only)</label>
          <input
            type="text"
            className="form-input-style"
            name="aboutBadgeBig"
            value={content.aboutBadgeBig || ''}
            onChange={handleChange}
            placeholder="10+"
          />
        </div>
      </div>

      <div className="form-row-2">
        <BilingualField
          label="Title (Regular Text)"
          fieldName="aboutTitleRegular"
          value={content.aboutTitleRegular}
          onChange={handleBilingualChange}
          placeholder="A Platform Built "
        />
        <BilingualField
          label="Title (Gold Italic Text)"
          fieldName="aboutTitleGold"
          value={content.aboutTitleGold}
          onChange={handleBilingualChange}
          placeholder="For Dancers"
        />
      </div>

      <BilingualField
        label="Badge Small Text (Use \n for new lines)"
        fieldName="aboutBadgeSmall"
        value={content.aboutBadgeSmall}
        onChange={handleBilingualChange}
        isTextarea
        rows={2}
        placeholder="Years\nof dance"
      />

      <BilingualField
        label="Subtext Paragraph"
        fieldName="aboutSubtext"
        value={content.aboutSubtext}
        onChange={handleBilingualChange}
        isTextarea
        rows={3}
      />

      <h4 style={{ fontSize: 14, fontWeight: 600, marginTop: 24, marginBottom: 16 }}>Features (4 items)</h4>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        {content.aboutFeatures?.map((f, idx) => (
          <div key={idx} style={{ padding: 16, border: '1px solid var(--border)', borderRadius: 8, background: '#fafafa' }}>
            <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
              <div style={{ flex: '0 0 60px' }}>
                <label className="form-label-style" style={{ fontSize: 11 }}>Emoji</label>
                <input type="text" className="form-input-style" value={f.emoji} onChange={e => handleFeatureChange(idx, 'emoji', e.target.value)} />
              </div>
            </div>
            <BilingualField
              label="Feature Title"
              fieldName={`feature_title_${idx}`}
              value={f.title}
              onChange={(_, lang, val) => handleFeatureChange(idx, 'title', { ...f.title, [lang]: val })}
              placeholder="e.g. Attendance Tracking"
            />
            <BilingualField
              label="Feature Description"
              fieldName={`feature_desc_${idx}`}
              value={f.desc}
              onChange={(_, lang, val) => handleFeatureChange(idx, 'desc', { ...f.desc, [lang]: val })}
              isTextarea
              rows={2}
            />
          </div>
        ))}
      </div>

      <div className="form-group" style={{ marginTop: 24 }}>
        <label className="form-label-style">About Image</label>
        <div style={{ display: 'flex', gap: 20, alignItems: 'flex-start' }}>
          <div
            style={{
              width: 150,
              height: 200,
              background: '#f0f0f0',
              borderRadius: 8,
              backgroundImage: aboutImagePreview ? `url("${aboutImagePreview}")` : (content.aboutImageUrl ? `url("${resolveImage(content.aboutImageUrl)}")` : 'none'),
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              border: '1px solid var(--border)'
            }}
          />
          <div>
            <input type="file" accept="image/*" onChange={(e) => handleImageChange(e, 'about')} style={{ marginBottom: 12 }} />
            <p className="text-sm text-muted">Recommended size: 900x1200px portrait.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
